import { makeStyles } from "@fluentui/react-components";

export const useSuggestionRankingFormStyles = makeStyles({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    alignItems: "flex-start",
    rowGap: "24px",
    overflow: "hidden",
    padding: "16px 0",
    boxSizing: "border-box",
  },
  toolbarContainer: {
    textAlign: "center",
    boxSizing: "border-box",
    width: "100%",
    padding: "0 20px",
  },
  formActionContainer: {
    display: "flex",
    flexDirection: "row",
    columnGap: "16px",
    width: "100%",
    boxSizing: "border-box",
    padding: "0 20px",
    "@media screen and (max-width: 500px)": {
      flexDirection: "column",
      gap: "8px",
    },
  },
  fullWidth: {
    minWidth: "100%",
  },
  formRow: {
    width: "100%",
    flex: "0 0.8 auto",
    overflowY: "auto",
    overflowX: "hidden",
  },
  filterForm: {
    display: "flex",
    flex: 1,
    minHeight: 0,
    flexDirection: "column",
    rowGap: "24px",
    width: "100%",
    boxSizing: "border-box",
    padding: "0 20px",
    overflowY: "auto",
    overflowX: "hidden",
  },
  filterFormField: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    rowGap: "10px",
    boxSizing: "border-box",
  },
  formActionBtn: {
    minWidth: "165px",
    fontWeight: "bold",
  },

  popOverTrigger: {
    position: "relative",
    minWidth: "32px",
  },
  popOverTriggerActive: {
    zIndex: "1000",
    backgroundColor: "white",
    borderRadius: "50%",
  },
  popOverTriggerBadge: {
    position: "absolute",
    top: "0px",
    left: "0px",
  },
  filterContainerSurface: {
    padding: "0px",
    height: "60vh",
    width: "430px",
    overflow: "hidden",
    "@media screen and (max-height: 800px)": {
      height: "70vh",
    },
    "@media screen and (max-width: 500px)": { width: "80vw" },
  },
});
